import React from 'react';
import { Card, CardContent, Typography, Box, useTheme, Tooltip, IconButton } from '@mui/material';
import { TrendingUp, TrendingDown, Equalizer, InfoOutlined } from '@mui/icons-material';

const DashboardCard = ({ title, value, subtitle, icon, trend, trendValue, tooltip }) => {
  const theme = useTheme();

  const getTrendIcon = () => {
    if (trend === 'up') {
      return <TrendingUp sx={{ color: theme.palette.success.main }} />;
    } else if (trend === 'down') {
      return <TrendingDown sx={{ color: theme.palette.error.main }} />;
    }
    return <Equalizer sx={{ color: theme.palette.info.main }} />;
  };

  return (
    <Card sx={{ height: '100%' }}>
      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
          <Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              <Typography color="textSecondary" variant="body2" gutterBottom sx={{ mb: 0 }}>
                {title}
              </Typography>
              {tooltip && (
                <Tooltip title={tooltip} arrow>
                  <IconButton size="small" sx={{ p: 0.25, mb: '2px' }}>
                    <InfoOutlined sx={{ fontSize: 16, color: theme.palette.text.secondary }} />
                  </IconButton>
                </Tooltip>
              )}
            </Box>
            <Typography variant="h4" component="div">
              {value}
            </Typography>
            {subtitle && (
              <Typography variant="body2" color="textSecondary">
                {subtitle}
              </Typography>
            )}
          </Box>
          <Box sx={{ color: theme.palette.primary.main }}>
            {icon}
          </Box>
        </Box>
        
        {trend && (
          <Box sx={{ display: 'flex', alignItems: 'center', mt: 2 }}>
            {getTrendIcon()}
            <Typography
              variant="body2"
              sx={{
                ml: 1,
                color: trend === 'up' ? theme.palette.success.main : theme.palette.error.main,
              }}
            >
              {trendValue} {trend === 'up' ? 'increase' : 'decrease'} from last month
            </Typography>
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default DashboardCard;